<div class="container">
  <div class="header_container mb-5">
    <div class="d-flex align-items-center">
      <h1 translate>vehicles.imports.requestForImports</h1>
    </div>
  </div>
  <ng-container *ngIf="!isLoading; else loadingData">
    <ng-container *ngIf="imports?.length; else noData">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12"
          *ngFor="let import of imports | slice: (page-1) * perPage : (page-1) * perPage + perPage; let index = index">
          <div class="card">
            <div class="p-2" (click)="navigateToVehicle(import)">
              <p class="text-row"><strong>Create at:</strong> {{import.createdAt | date:'dd.MM.yyyy HH:mm' }}</p>
              <hr>
              <!-- Display parsed message data -->
              <ng-container *ngIf="import.message; else noMessage">
                <div *ngFor="let data of parseMessage(import.message)">
                  <p class="text-row"><strong>{{data.key}}:</strong> {{data.value}}</p>
                </div>
              </ng-container>
              <ng-template #noMessage>
                <p translate><strong>Vin:</strong> {{import.vehicle.vin}}</p>
                <p translate><strong>User name:</strong> {{import.user.name}}</p>
                <p translate><strong>User email:</strong> {{import.user.email}}</p>
              </ng-template>
              <hr>
              <p class="text-row"><strong>Client:</strong> {{import.user.client?.name }}</p>
              <p class="text-row"><strong>Customer:</strong> {{import.user.customer?.name }}</p>
            </div>
            <div class="root-application-image-delete" style="cursor: pointer;"
              (click)="openDeleteModal(dialogDelete, import)"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noData>
      <div class="row">
        <p translate>vehicles.imports.noImports</p>
      </div>
    </ng-template>
    <ngb-pagination *ngIf="imports.length > 9" [collectionSize]="imports.length" [(pageSize)]="perPage" [(page)]="page"
      [maxSize]="5" [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
  </ng-container>
  <ng-template #loadingData>
    <div *appSpinner="isLoading; message: 'Loading...'"></div>
  </ng-template>
</div>

<!-- Modal delete frame-->
<ng-template #dialogDelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" style="font-size: 16px" translate>vehicles.imports.deleteMsg <span
        style="font-weight: bold;"> {{selectedImport.vehicle.vin}}</span>?</h3>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteImport()" translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>